export default "__VITE_ASSET__GipeBVX0__"